import { render, staticRenderFns } from "./all-case-list.vue?vue&type=template&id=67f38598"
import script from "./all-case-list.vue?vue&type=script&lang=ts"
export * from "./all-case-list.vue?vue&type=script&lang=ts"
import style0 from "./all-case-list.vue?vue&type=style&index=0&id=67f38598&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports